<div>

    <ng-template #reorderPopup>
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="closeHtmlContent()" mat-button><i
                class="fa popupClose">&#xf00d;</i></button>
        <!-- <h2 mat-dialog-title class="close-button">ONE-<span style="color:gold;">QMS</span></h2> -->

        <div mat-dialog-title>
            <label for="title" class="popupTitle"> {{title}}</label>
            <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
        </div>
        <!-- <button style="background: #005C8A;margin-right: 1%;" class="close close-button" (click)="closeHtmlContent()" mat-button><i
                class="fa popupClose">&#xf00d;</i></button> -->
        <!-- <div mat-dialog-title>
                    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
                    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
                </div> -->
        <!-- <div *ngFor="let item of Lists" class="row myTrainingLeftPlace" style="height: auto;max-height: 500px;overflow-y: auto;overflow-x: hidden;">
                    {{item.changedFieldName}}
                </div> -->
        <div class="table-container" style="margin:15px">
            <span class="align-center">
                <b> Drag and drop to reorder the Columns</b>&nbsp;
                (Minimum Field Size is 100 and Maximum Field Size is 400)
            </span>
            <div class="align-center" *ngIf="qualityAlert">
                <b><span style="color:red">Warning!</span>
                    &nbsp;Grid</b>&nbsp; changes made here will reflect in all &nbsp;<b>other</b>&nbsp; Quality Modules
                as well.
            </div>
            <br>
            <div class="align-center">
                <table style="max-height: 500px;">
                    <thead>
                        <th style="width: 80px; text-align: center;overflow: hidden;text-overflow: 'ellipsis';
                white-space: 'nowrap'"> <span>Curr. Seq.</span> <span id="grid-header-container"></span> </th>
                        <th style="width:220px;text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                white-space: 'nowrap'"> <span>Field Name</span> <span id="grid-header-container"></span> </th>
                        <th [hidden]="showremoveableField==false" style=" width: 150px;text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                white-space: 'nowrap'"> <span>Hide</span> <span id="grid-header-container"></span> </th>
                        <th style="width: 360px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                white-space: 'nowrap'"> <span>Changed Field Name</span> <span id="grid-header-container"></span> </th>
                        <th style="width: 150px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                white-space: 'nowrap'"> <span>Show in Grid</span> <span id="grid-header-container"></span> </th>
                        <th style="width: 100px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                white-space: 'nowrap'"> <span>Field Size</span> <span id="grid-header-container"></span> </th>
                        <th style="width: 80px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                white-space: 'nowrap'"> <span>New Seq.</span> <span id="grid-header-container"></span> </th>
                        <th [hidden]="showremoveableField==false" style="width: 180px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                white-space: 'nowrap'"> <span>Note</span> <span id="grid-header-container"></span> </th>
                    </thead>
                    <tbody cdkDropList (cdkDropListDropped)="drop($event)">
                        <tr cdkDrag cdkDragLockAxis="y" cdkDragHandle *ngFor="let item of contentList let idx = index;">
                            <td id="grid-row-container" style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
                  white-space: 'nowrap'"><span>{{item.currentSeq}}</span></td>
                            <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                   white-space: 'nowrap'"><span>{{item.fieldName}}</span></td>
                            <td [hidden]="showremoveableField==false" id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                   white-space: 'nowrap'">
                                <mat-checkbox color="primary"
                                    [hidden]="item.isFieldRemovable=='NA'||item.isFieldRemovable==null || item.isFlexiField=='Y'"
                                    [(ngModel)]="item.isFieldRemovable1">
                                    <span>Yes</span>
                                </mat-checkbox>
                                <!-- <span>{{item.addedInGrid}}</span> -->
                                <!-- <mat-radio-group class="tp-radio-group" [(ngModel)]="item.addedInGrid">
                                   <mat-radio-button class="tp-radio-button" *ngFor="let status of item.radioValue"
                                       [value]="status.valueExp">
                                       {{status.displayExp}}
                                   </mat-radio-button>
                               </mat-radio-group> -->
                            </td>
                            <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'">
                                <!-- <span>{{item.changedFieldName}}</span> -->
                                <input type="text" class="col-md-6 input-filed-continers"
                                    [(ngModel)]="item.changedFieldName">
                            </td>
                            <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'">
                                <!-- <span>{{item.addedInGrid}}</span> -->
                                <mat-radio-group class="tp-radio-group" [(ngModel)]="item.addedInGrid">
                                    <mat-radio-button class="tp-radio-button" *ngFor="let status of item.radioValue"
                                        [value]="status.valueExp">
                                        {{status.displayExp}}
                                    </mat-radio-button>
                                </mat-radio-group>
                            </td>
                            <td id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'">
                                <!-- <span>{{item.fieldSize}}</span> -->
                                <input type="number" id="{{idx+100}}" min="1" max="400"
                                    class="col-md-6 input-filed-continers" [(ngModel)]="item.fieldSize"
                                    (keydown)="validateNumberFields($event)" (focusout)="rangevalidation($event,idx)">
                            </td>
                            <td id="grid-row-container " style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'"><span>{{item.newSeq}}</span></td>
                            <td [hidden]="showremoveableField==false" id="grid-row-container" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
                    white-space: 'nowrap'">
                                <input type="text" class="col-md-6 input-filed-continers" [(ngModel)]="item.fieldNotes"
                                    maxlength="150" (input)="checkLength($event)">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="button-continer" mat-dialog-actions class="btn-align">
            <button mat-stroked-button class="addButton" (click)="confirmPopup1()">
                <i class="fa fa-redorder"></i> Reset To Factory
            </button>
            <button mat-stroked-button class="addButton" (click)="reorderContentFunction(true)">
                <i class="fa fa-redorder"></i> Save
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelReorderFunction()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>

    </ng-template>

    <ng-template #confirmPopup>
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="cancelconfirmmethod()" mat-button><i
                class="fa popupClose">&#xf00d;</i></button>

        <div mat-dialog-title>
            <label for="title" class="popupTitle"> {{title}}</label>
        </div>
        <label for="title" class="p-2 px-4" style="font-size: larger;">This action will reset the grid settings to
            default factory setting</label>
        <div class="button-continer" mat-dialog-actions class="btn-align">
            <button mat-stroked-button class="addButton" (click)="reorderContentFunction(false)">
                <i class="fa fa-redorder"></i> Yes
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelconfirmmethod()">
                <i class="fa fa-close"></i> No
            </button>
        </div>
    </ng-template>
</div>